import { ModelTermAcceptanceDialog } from "@/components/dialogs/model-term-acceptance";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import type { ExpandedModel } from "@/shared/data/models";
import { AlertTriangle } from "lucide-react";

export function ModelTermsWarning({
  model,
  onAccept,
  className,
  iconSize = 16,
}: {
  model: ExpandedModel;
  onAccept: () => void;
  className?: string;
  iconSize?: number | undefined;
}) {
  return (
    <div
      className={cn(
        "text-xs flex gap-3 px-4 py-3 items-center justify-center",
        className,
      )}
    >
      <AlertTriangle size={iconSize} />
      <span className="pb-0">
        Model terms are required to be{" "}
        <ModelTermAcceptanceDialog
          id={model.id}
          termsURL={model.terms_url || ""}
          onSuccess={() => {
            onAccept();
          }}
        >
          <Button
            variant={"link"}
            className="px-0 text-xs hover:underline h-0 text-primaryaccent dark:font-medium"
          >
            accepted
          </Button>
        </ModelTermAcceptanceDialog>{" "}
        for {model.id}.
      </span>
    </div>
  );
}
